import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import { JandiLogo } from '@/components/assets/logos/svgs';
import { Link } from 'react-router-dom';
import LanguageDropdown from '@/components/selectLanguage';

/** Fixed mobile bar height (Toolbar), excluding iOS safe-area inset. */
export const MOBILE_HEADER_BAR_HEIGHT_PX = 80;

export default function MobileHeader({ onMenuClick }: { onMenuClick: () => void }) {
  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        top: 0,
        left: 0,
        right: 0,
        // Solid background — backdrop-filter often fails to paint in Instagram WKWebView
        backgroundColor: '#ffffff',
        backgroundImage: 'none',
        boxShadow: 'none',
        borderBottom: '1px solid #f0f0f0',
        zIndex: 3000,
        // Keep logo/menu below iOS notch / Instagram in-app chrome
        paddingTop: 'env(safe-area-inset-top, 0px)',
        // Force a compositor layer so the bar is not blank in WKWebView
        WebkitTransform: 'translateZ(0)',
        transform: 'translateZ(0)',
        opacity: 1,
        visibility: 'visible',
      }}
    >
      <Toolbar
        sx={{
          minHeight: `${MOBILE_HEADER_BAR_HEIGHT_PX}px !important`,
          height: `${MOBILE_HEADER_BAR_HEIGHT_PX}px`,
          px: 3,
          display: 'flex',
          justifyContent: 'space-between',
          backgroundColor: '#ffffff',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', height: 40, gap: 1 }}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
            <JandiLogo style={{ height: 40 }} />
          </Link>
          <Box sx={{ ml: 1 }}>
            <LanguageDropdown />
          </Box>
        </Box>
        <IconButton
          edge="end"
          color="inherit"
          aria-label="menu"
          onClick={onMenuClick}
          sx={{ WebkitTapHighlightColor: 'transparent' }}
        >
          <span style={{ fontWeight: 900, fontSize: 32, color: '#222', lineHeight: 1 }}>&#9776;</span>
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}
